require('!!raw-loader!/builds/903873/v2/src/index.html');